<template>
  <div>
    <v-row>
      <v-col cols="12">
        <div class="form-base__title">{{ label }}</div>
      </v-col>

      <v-col cols="4">
        <v-text-field
          v-model.trim="v.lastName.$model"
          :errorMessages="getValidationErrorText(v.lastName)"
          label="Фамилия"
          outlined
        />
      </v-col>
      <v-col cols="4">
        <v-text-field
          v-model.trim="v.firstName.$model"
          :errorMessages="getValidationErrorText(v.firstName)"
          label="Имя"
          outlined
        />
      </v-col>
      <v-col cols="4">
        <v-text-field
          v-model.trim="v.patronymic.$model"
          :errorMessages="getValidationErrorText(v.patronymic)"
          label="Отчество (при наличии)"
          outlined
        />
      </v-col>

      <v-col cols="4">
        <v-text-field
          v-model="v.snils.$model"
          :errorMessages="getValidationErrorText(v.snils)"
          :label="FieldLabel.SNILS"
          v-mask="Mask.SNILS"
          outlined
        />
      </v-col>
      <v-col cols="4">
        <v-text-field
          v-model="v.inn.$model"
          :errorMessages="getValidationErrorText(v.inn)"
          :label="FieldLabel.INN"
          v-mask="Mask.INN"
          outlined
        />
      </v-col>

      <v-col cols="6">
        <v-text-field
          v-model="v.trusteeStatus.$model"
          :errorMessages="getValidationErrorText(v.trusteeStatus)"
          :label="FieldLabel.TRUSTEE_STATUS"
          outlined
        />
      </v-col>
    </v-row>

    <EgrnOrganizationAuthorityDocument :v="v.documents.authorityDocument" />

    <v-row>
      <v-col cols="3">
        <v-text-field
          v-model="v.email.$model"
          :errorMessages="getValidationErrorText(v.email)"
          label="Адрес электронной почты"
          outlined
        />
      </v-col>
      <v-col cols="3">
        <v-text-field
          v-model="v.phone.$model"
          :errorMessages="getValidationErrorText(v.phone)"
          v-mask="['+7 ### ###-##-##']"
          label="Контактный телефон"
          outlined
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { maxLength, minLength, required } from 'vuelidate/lib/validators';
import {
  EMAIL,
  EMOJI,
  getValidationErrorText,
  INN,
  MAX_LENGTH,
  MAX_LENGTH_EMAIL,
  MinLength,
  PERSON_NAME,
} from '@/utils/validate';
import { DocumentType } from '@/types/services';
import { FieldLabel, FieldName, Mask } from '@/constants';
import EgrnOrganizationAuthorityDocument, {
  egrnOrganizationAuthorityDocumentModel,
  getEgrnOrganizationAuthorityDocumentValidation,
} from '@/components/services/elements/EgrnOrganizationAuthorityDocument';
import cloneDeep from 'clone-deep';
import { AuthModule } from '@/store/modules/auth';

export const getOrganizationTrusteeValidation = (trustee) => {
  return {
    lastName: {
      required,
      maxLength: maxLength(MAX_LENGTH),
      PERSON_NAME,
    },
    firstName: {
      required,
      maxLength: maxLength(MAX_LENGTH),
      PERSON_NAME,
    },
    patronymic: {
      maxLength: maxLength(MAX_LENGTH),
      PERSON_NAME,
    },
    snils: {
      required,
      minLength: minLength(MinLength.SNILS),
    },
    inn: {
      minLength: minLength(12),
      required,
      INN: INN(12),
    },
    trusteeStatus: {
      maxLength: maxLength(1000),
      EMOJI,
    },
    email: {
      required,
      EMAIL,
      maxLength: maxLength(MAX_LENGTH_EMAIL),
    },
    phone: {
      required,
      minLength: minLength(16),
    },
    documents: {
      authorityDocument: getEgrnOrganizationAuthorityDocumentValidation(
        trustee.documents.authorityDocument
      ),
    },
  };
};

export const organizationTrusteeModel = {
  lastName: '',
  firstName: '',
  patronymic: '',
  snils: '',
  inn: '',
  trusteeStatus: '',
  email: '',
  phone: '',
  documents: {
    authorityDocument: cloneDeep(egrnOrganizationAuthorityDocumentModel),
  },
};

export const prefillEsiaOrgTrustee = async () => {
  const esiaPerson = await AuthModule.getPerson();
  const trustee = {};

  Object.keys(organizationTrusteeModel).forEach((fieldName) => {
    trustee[fieldName] =
      esiaPerson[fieldName] ?? organizationTrusteeModel[fieldName];
  });

  return cloneDeep(trustee);
};

export default {
  name: 'OrganizationTrustee',
  components: {
    EgrnOrganizationAuthorityDocument,
  },
  props: {
    v: {
      type: Object,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    getValidationErrorText,
    DocumentType,
    Mask,
    FieldName,
    FieldLabel,
  }),
};
</script>
